import React, { FC } from 'react'

import { useHandleBack } from 'components/page/PhotoViewer/hooks/useHandleBack'
import { Wrapper } from 'components/page/PhotoViewer/Panel/PanelTop/PanelTop.styled'
import { PanelTopView } from 'components/page/PhotoViewer/Panel/PanelTop/PanelTopView'
import { PhotoViewerCloseButton } from 'components/page/PhotoViewer/PhotoViewerCloseButton/PhotoViewerCloseButton'
import { PhotoViewerIconsAndTooltip } from 'components/page/PhotoViewer/PhotoViewerIconsAndTooltip'
import { useAuthorized } from 'hooks/useAuthorized'

import { usePhotos } from '../../hooks/usePhotos'

export const PanelTop: FC<{
  isAttachPhotos?: boolean
  selectedPhotoIndex: number
  isShowPanel?: boolean
}> = ({ selectedPhotoIndex, isAttachPhotos = false, isShowPanel = true }) => {
  const authorized = useAuthorized()
  const { totalPhotos } = usePhotos()

  const handleClosePhotoViewer = useHandleBack()

  if (!isShowPanel) {
    return (
      <Wrapper>
        <PhotoViewerCloseButton onClosePhotoViewer={handleClosePhotoViewer} />
      </Wrapper>
    )
  }

  if (!authorized || isAttachPhotos) {
    return (
      <PanelTopView
        selectedPhotoIndex={selectedPhotoIndex}
        totalPhotos={totalPhotos}
        onClosePhotoViewer={handleClosePhotoViewer}
      />
    )
  }

  return (
    <PanelTopView
      selectedPhotoIndex={selectedPhotoIndex}
      totalPhotos={totalPhotos}
      onClosePhotoViewer={handleClosePhotoViewer}
      menuTooltip={
        <PhotoViewerIconsAndTooltip selectedPhotoIndex={selectedPhotoIndex} />
      }
    />
  )
}
